import { Component, EventEmitter, HostBinding, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core'
import { Inquiry } from '@tv3/store/inquiry/inquiry.model'
import * as R from 'ramda'
import { messageSidebarAnimation } from '@tv3/animations/message-sidebar.animation'
import { InquiryChargeService } from '@tv3/services/inquiry-charge.service'
import { take } from 'rxjs/operators'
import { InquiryService } from '@tv3/store/inquiry/inquiry.service'
import { isSomething } from '@tokeet/tv3-platform'
import { InquiryCost, isExternalBookingSource } from '@tokeet/cost-resolver'
import { InquiryChannelBreakdownDialogsService } from '@tv3/containers/inquiries/dialogs/inquiry-channel-breakdown-dialog'

@Component({
  selector: 'app-booking-charges',
  templateUrl: './booking-charges.component.html',
  styleUrls: ['./booking-charges.component.scss'],
  animations: [messageSidebarAnimation],
})
export class BookingChargesComponent implements OnInit, OnChanges {
  @HostBinding('class') classes = 'clearfix default-box-holder'

  @Input() title = 'Booking Charges'
  @Input() inquiry: Inquiry
  @Input() header: string
  @Input() editable = true

  @Output() edit = new EventEmitter()

  isExpanded = true
  expanded: string

  tooltipText = 'Edit booking charges'

  currencySymbol: string
  currencyCode: string

  charges: InquiryCost

  external = false
  hasChannelPrice = false

  constructor(
    private inquiryChargeService: InquiryChargeService,
    public inquiryService: InquiryService,
    private inquiryChannelBreakdownDialogs: InquiryChannelBreakdownDialogsService
  ) {}

  ngOnInit() {}

  onToggle() {
    this.isExpanded = !this.isExpanded
    this.expanded = this.isExpanded ? 'active' : 'inactive'
  }

  tryToGetFormulaCost(inquiryService: InquiryService, inquiry: Inquiry) {
    return inquiryService.getCostAfterFormula(inquiry.id)
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (R.hasIn('inquiry', changes) && this.inquiry) {
      this.currencySymbol = this.inquiry?.rental?.currency?.symbol
      this.currencyCode = this.inquiry?.rental?.currency?.code

      this.hasChannelPrice = this.inquiryChannelBreakdownDialogs.hasChannelPrice(this.inquiry)
      this.external =
        !!this.inquiry.booked && isSomething(this.inquiry.cost) && isExternalBookingSource(this.inquiry.inquirySource)

      this.inquiryChargeService
        .getCharges(this.inquiry)
        .pipe(take(1))
        .subscribe((inquiry) => {
          this.charges = inquiry.charges
        })
    }
  }

  onChannelBreakdown() {
    this.inquiryChannelBreakdownDialogs.onChannelBreakdown(this.inquiry, this.currencySymbol)
  }
}
